import React, { useEffect, useState } from 'react';
import Layout from '../../../components/Layout/Layout';
import api from '../../../api/axios';
import '../../superadmin/Dashboard/SuperAdminDashboard.css';

export default function CustomerAdminDashboard() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get('/dashboard/customer').then(res => setData(res.data));
  }, []);

  return (
    <Layout title="Dashboard">
      <div className="sad-stats">
        <div className="stat-card">
          <span className="stat-value">{data?.totalEmployees ?? '–'}</span>
          <span className="stat-label">Mitarbeiter</span>
        </div>
        <div className="stat-card">
          <span className="stat-value">{data?.completedTrainings ?? '–'}</span>
          <span className="stat-label">Abgeschlossene Schulungen</span>
        </div>
        <div className="stat-card">
          <span className="stat-value">{data?.pendingTrainings ?? '–'}</span>
          <span className="stat-label">Offene Schulungen</span>
        </div>
        <div className="stat-card">
          <span className="stat-value">{data?.totalTrainings ?? '–'}</span>
          <span className="stat-label">Schulungen gesamt</span>
        </div>
      </div>

      {data?.recentCompletions?.length > 0 && (
        <div className="card" style={{ marginTop: '1.5rem' }}>
          <h2 style={{ marginBottom: '1rem', fontSize: '1rem', fontWeight: 700 }}>Letzte Abschlüsse</h2>
          <div className="table-container">
            <table>
              <thead>
                <tr><th>Mitarbeiter</th><th>Schulung</th><th>Abgeschlossen am</th></tr>
              </thead>
              <tbody>
                {data.recentCompletions.map((r, i) => (
                  <tr key={i}>
                    <td style={{ fontWeight: 500 }}>{r.userName}</td>
                    <td>{r.trainingTitle}</td>
                    <td>{new Date(r.completed_at).toLocaleDateString('de-DE')}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </Layout>
  );
}
